import invariant from 'invariant';
import authenticatedRequest from '../authenticatedRequest';
import labelRequest from '../labelRequest';

function getRequestLocale(locale) {
    if (typeof locale === 'undefined' || !locale) {
        return '';
    }

    const language = locale.split('_').shift();
    const countryMap = {
        en: 'en_US',
        fr: 'fr_FR',
        de: 'de_DE',
        zh: 'zh_CN',
        ar: 'ar_AE',
        ja: 'ja_JP',
        it: 'it_IT',
        ko: 'ko_KR',
    };

    const mappedCountry = countryMap?.[language];
    return mappedCountry ? `?locale=${mappedCountry}` : '';
}

export default function getCountries(params) {
    let { baseUrl, brandId, clientId, locale } = params;

    invariant(baseUrl, 'baseUrl is a required param of getCountries()');
    invariant(brandId, 'brandId is a required param of getCountries()');
    invariant(clientId, 'clientId is a required param of getCountries()');

    const queryString = getRequestLocale(locale);

    const url = `${baseUrl}wcs/resources/store/${brandId}/v2/countries${queryString}`;
    return labelRequest(authenticatedRequest(new Request(url), null, clientId), 'getCountries');
}

//for requestWithLogger and locale parser middleware
export function getCountriesForRequest(params) {
    let { baseUrl, brandId, clientId, locale, options } = params;

    invariant(baseUrl, 'baseUrl is a required param of getCountriesForRequest()');
    invariant(brandId, 'brandId is a required param of getCountriesForRequest()');
    invariant(clientId, 'clientId is a required param of getCountriesForRequest()');

    const queryString = getRequestLocale(locale);

    const url = `${baseUrl}wcs/resources/store/${brandId}/v2/countries${queryString}`;

    return {
        url,
        headers: {
            'X-Ibm-Client-ID': clientId,
        },
        ...options,
    };
}
